var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"todoList"},_vm._l((_vm.Todos),function(todo){return _c('div',{key:todo},[_c('p',{on:{"click":function($event){return _vm.DELETE_TODO(todo)}}},[_vm._v(_vm._s(todo.todo))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('strong',[_vm._v(" ToDo Listem ")])])
}]

export { render, staticRenderFns }